<script>
	import { getContext } from 'svelte';
	import DraggableComponent from '@Components/DraggableComponent.svelte';
	export let isVisible = false;
	export let group = null;
	const { getController } = getContext('editor');
	const controller = getController();
	let selectedGroup = null;
	let timer;
	$: isDarkMode = window.isDarkMode;
	$: fields = [];
	$: (selectedGroup = group), updateValues();
	window.addEventListener('colorSchemeChanged', (e) => {
		isDarkMode = e.isDarkMode;
	});
	let values = {
		theme: 'park',
		holecolor: '#ffffff',
		holetextcolor: '#000000'
	};
	let defaultFields = [
		{
			type: 'select',
			name: 'theme',
			title: 'Theme',
			tooltip: 'The theme for the group. Impacts rendering of the holes and overview',
			options: [
				{
					title: 'Park',
					value: 'park'
				},
				{
					title: 'Links',
					value: 'links'
				},
				{
					title: 'Forest',
					value: 'forest'
				}
			]
		},
		{
			type: 'color',
			name: 'holecolor',
			title: 'Color of holes',
			tooltip: 'Changes the background color of the holes in the overview',
			options: [
				{
					title: 'Red',
					value: 'park'
				},
				{
					title: 'Links',
					value: 'links'
				},
				{
					title: 'Forest',
					value: 'forest'
				}
			]
		},
		{
			type: 'color',
			name: 'holetextcolor',
			title: 'Color of hole text',
			tooltip: 'Changes the text color of the holes in the overview',
			options: [
				{
					title: 'Red',
					value: 'park'
				},
				{
					title: 'Links',
					value: 'links'
				},
				{
					title: 'Forest',
					value: 'forest'
				}
			]
		}
	];
	function updateValues() {
		if (group) {
			values.theme = controller.getGroupSetting(group.id, 'theme') ?? 'park';
			values.holecolor = controller.getGroupSetting(group.id, 'holecolor') ?? '#ffffff';
			values.holetextcolor = controller.getGroupSetting(group.id, 'holetextcolor') ?? '#000000';
			fields = defaultFields;
		}
	}
	function getTitle() {
		if (selectedGroup) {
			return selectedGroup.name;
		}
		return 'Group';
	}
	
	function throttle(callback, ms = 200) {
		clearTimeout(timer);
		timer = setTimeout(callback, ms);
	}
</script>

<DraggableComponent initialX="10" initialY="60" yAlignment="bottom" closable={true} bind:visible={isVisible}>
	<div class="flex text-sm flex-col text-left pt-0">
		<div class="text-left w-full font-bold p-2 pt-0 select-none">{getTitle()}</div>
		<div class="flex text-sm flex-col gap-2 bg-neutral-200 dark:bg-bigsteel-900/20 p-2 w-52">
			{#each fields as field}
				{#if field.type == 'select'}
					<label tooltip={field.tooltip} for={field.name}>{field.title}</label>
					<select
						bind:value={values[field.name]}
						name={field.name}
						class:dark-select={isDarkMode}
						on:change={(e) => {
							if (selectedGroup) {
								throttle(() => {
									controller.saveGroupSetting(selectedGroup.id, field.name, e.target.value);
								});
							}
						}}
					>
						{#each field.options as option}
							<option value={option.value}>{option.title}</option>
						{/each}
					</select>
				{:else if field.type == 'color'}
				<div class="flex flex-row gap-2 items-center">
					
					<input
						bind:value={values[field.name]}
						name={field.name}
						type="color"
						class:dark-color-input={isDarkMode}
						on:change={(e) => {
							if (selectedGroup) {
								controller.saveGroupSetting(selectedGroup.id, field.name, e.target.value);
							}
						}}
					/>
					<label for={field.name} tooltip={field.tooltip}>{field.title}</label>
				</div>
				{/if}
			{/each}
		</div>
	</div>
</DraggableComponent>

<style lang="postcss">
	input[type='color'] {
		width: 16px;
		height: 16px;
		border-radius: 8px;
		cursor: pointer;
	}
	input[type='color']::-webkit-color-swatch-wrapper {
		padding: 0;
	}
	input[type='color']::-webkit-color-swatch {
		border: none;
	}
</style>
